import React from "react";
import { MessageCircle } from "lucide-react";
import { HeroSection } from "../sections/HeroSection";
import { DigitalAwarenessSection } from "../sections/DigitalAwarenessSection";
import { AboutSection } from "../sections/AboutSection";
import { ServicesSection } from "../sections/ServicesSection";
import { TrialDemoPromo } from "../sections/TrialDemoPromo";
import { TrialDemoForm } from "../sections/TrialDemoForm";
import { DiantosanSection } from "../sections/DiantosanSection";
import { VisionMissionSection } from "../sections/VisionMissionSection";
import { TeamSection } from "../sections/TeamSection";
import { TrustSection } from "../sections/TrustSection";
import { FinalCTASection } from "../sections/FinalCTASection";
import { TestimonialAutoScrollSection } from "../sections/TestimonialAutoScrollSection";
import { ClientFeedSection } from "../sections/ClientFeedSection";
import { CaseStudyGallerySection } from "../sections/CaseStudyGallerySection";

import { contactInfo } from "../utils/mockData";

export const LandingPage = () => {
  const handleWhatsApp = () => {
    const message = "Halo, saya tertarik dengan layanan Dreams Marketing.";
    const url = `https://wa.me/${contactInfo.whatsapp.replace(/[^0-9]/g, "")}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <div className="min-h-screen bg-white dark:bg-[#0F0F0F]">
      {/* Hero Section */}
      <HeroSection />

      {/* Digital Problem Awareness */}
      <DigitalAwarenessSection />

      {/* About Dreams Marketing */}
      <AboutSection />

      {/* Services Section */}
      <ServicesSection />

      {/* Trial Demo Promo */}
      <TrialDemoPromo />

      {/* Trial Demo Form */}
      <TrialDemoForm />

      {/* Diantosan Program */}
      <DiantosanSection />

      {/* Vision & Mission */}
      <VisionMissionSection />

      {/* Team Section */}
      <TeamSection />

      {/* Testimonial Auto Scroll Section */}
      <TestimonialAutoScrollSection />

      {/* Client Feed Section */}
      <ClientFeedSection />

      {/* Case Study Gallery Section */}
      <CaseStudyGallerySection />

      {/* Trust Section */}
      <TrustSection />

      {/* Final CTA Section */}
      <FinalCTASection />

      {/* Sticky WhatsApp Button */}
      <button
        onClick={handleWhatsApp}
        className="fixed bottom-6 right-6 z-40 bg-[#25D366] hover:bg-[#20BA5A] text-white w-14 h-14 rounded-full shadow-lg flex items-center justify-center hover:scale-110 transition-transform"
        aria-label="WhatsApp"
      >
        <MessageCircle className="w-6 h-6" />
      </button>
    </div>
  );
};
